import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AppErrors } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';


@Injectable({
  providedIn: 'root'
})
export class RetailApiService {
  private http = inject(HttpClient);

  private readonly API_BASE_URL = environment.RETAIL_BILLING_URL;

   httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
    };

  protected buildParams(params: Record<string, any>): HttpParams {
    let httpParams = new HttpParams();
    
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.set(key, value.toString());
      }
    });
    
    return httpParams;
  }

  protected get<T>(endpoint: string, params?: Record<string, any>): Observable<T> {
    const options = params
      ? { params: this.buildParams(params), headers: this.httpOptions.headers }
      : { headers: this.httpOptions.headers };
    return this.http.get<T>(`${this.API_BASE_URL}${endpoint}`, options).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        return throwError(() => new AppErrors(error));
      })
    );
  }

  protected post<T>(endpoint: string, body?: any, params?: Record<string, any>): Observable<T> {
 const options = params
      ? { params: this.buildParams(params), headers: this.httpOptions.headers }
      : { headers: this.httpOptions.headers };  
      return this.http.post<T>(`${this.API_BASE_URL}${endpoint}`, body, options).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        return throwError(() => new AppErrors(error)) ;
      })
    );
  }

  protected put<T>(endpoint: string, body?: any, params?: Record<string, any>): Observable<T> { 
 const options = params
      ? { params: this.buildParams(params), headers: this.httpOptions.headers }
      : { headers: this.httpOptions.headers };
    return this.http.put<T>(`${this.API_BASE_URL}${endpoint}`, body, options).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        return throwError(() => new AppErrors(error)) ;
      })
    );
  }

  protected delete<T>(endpoint: string, params?: Record<string, any>): Observable<T> {
 const options = params
      ? { params: this.buildParams(params), headers: this.httpOptions.headers }
      : { headers: this.httpOptions.headers }; 
   return this.http.delete<T>(`${this.API_BASE_URL}${endpoint}`, options).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        return throwError(() => new AppErrors(error)) ;
      })
    );
  }
}